
import React from 'react';
import Layout from '@/components/Layout';

const CertificatesUserPage: React.FC = () => {
  return (
    <Layout>
      <div className="container py-10">
        <h1 className="text-3xl font-bold">My Certificates</h1>
        <p className="mt-4">View your earned certificates.</p>
      </div>
    </Layout>
  );
};

export default CertificatesUserPage;
